export default {
    setInterest (state, { interests }) {
        state.interests = interests
    },
    interestList (state, {interests}) {
        state.interestList = interests
    },
    SetUserInterests (state, {userInterests}) {
        state.userInterests = userInterests
    }
}



// WEBPACK FOOTER //
// ./src/store/interest/mutations.js